module.exports = __webpack_public_path__ + "img/76306.fa122ccd.svg";